export const paddleNumbers = (number) => {
  const $paddleNumbers = document.querySelectorAll('.x-bidlogix--templated-paddle')

  if ($paddleNumbers.length) {
    $paddleNumbers.forEach($paddleNumber => {
      if (number) {
        $paddleNumber.textContent = number
      } else {
        $paddleNumber.textContent = ''
      }
    })
  }
}

export const getUserTimezone = (timezoneId, timezoneGroups) => {
  if (!timezoneId || !timezoneGroups) {
    return false
  }
  for (let i = 0; i < timezoneGroups.length; i++) {
    for (let j = 0; j < timezoneGroups[i].children.length; j++) {
      if (timezoneGroups[i].children[j].id === timezoneId) {
        return timezoneGroups[i].children[j].code
      }
    }
  }

  return Intl.DateTimeFormat().resolvedOptions().timeZone
}

const bidderHelpers = {
  paddleNumbers,
  getUserTimezone
}

export default bidderHelpers
